import _path from "path-browserify";

export const resolve = _path.resolve;
export const normalize = _path.normalize;
export const isAbsolute = _path.isAbsolute;
export const join = _path.join;
export const relative = _path.relative;
export const dirname = _path.dirname;
export const basename = _path.basename;
export const extname = _path.extname;
export const format = _path.format;
export const parse = _path.parse;
export const sep = _path.sep;
export const delimiter = _path.delimiter;
export const win32 = _path.win32;
export const posix = _path.posix;
export default _path;
